import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { FormCheckboxWithDescriptionComponent } from 'src/app/components/playbooks/playbook-action/common/form-checkbox-with-description/form-checkbox-with-description.component';
import { IAutonomousWithTriggersComponent } from '../interfaces/autonomous-with-triggers.interface';

@Component({
  selector: 'app-autonomous-with-triggers',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormCheckboxWithDescriptionComponent],
  templateUrl: './autonomous-with-triggers.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutonomousWithTriggersComponent implements IAutonomousWithTriggersComponent {
  public fg = input.required<UntypedFormGroup>();
  public ignoreIfAutonomousWithTriggers = model.required<boolean>();
  public labelKey = input.required<string>();

  public getLabelKey(): string {
    return this.labelKey();
  }

  public getTitleLabelKey(): string {
    return this.labelKey() + '.ignoreIfAutonomousWithTriggersTitle';
  }

  public getDescriptionLabelKey(): string {
    return this.labelKey() + '.ignoreIfAutonomousWithTriggersDescription';
  }
}
